import { render, staticRenderFns } from "./generalStatusBadge.vue?vue&type=template&id=548101bc&"
import script from "./generalStatusBadge.vue?vue&type=script&lang=js&"
export * from "./generalStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports